export const bemIfy = function (b: string, e?: string, m?: string): string {
  let output = b;
  output += e ? "__" + e : "";
  output = m ? output + " " + output + "--" + m : output;
  return output.toLowerCase();
};
